/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";

export const getBubblesMeta = () => {
  return progressApi.get("/UnityData/GetUnityBubbleMeta");
};

export const getBubblesData = () => {
  return progressApi.get("/UnityData/GetUnityBubbleData");
  // return api.get("/Unity/GetUnityBubbleData?dateTime=2023-10-02T22%3A46%3A00.000");
};

export const updateBubblePosition = (data: any) => {
  return progressApi.post("/Unity/UpdateBubbleCordinates", data);
};

export const getNotes = () => {
  return progressApi.get("/UnityData/GetUnityNoteMeta");
};

export const getEquipment = (id: any) => {
  return progressApi.get(`/UnityData/GetEquipment?id=${id}`);
};

export const getUnit = (id: any) => {
  return progressApi.get(`/UnityData/GetUnit?id=${id}`);
};

export const getNote = (id: any) => {
  return progressApi.get(`Unity/GetNote?id=${id}`);
};

export const getBubble = (id: any) => {
  return progressApi.get(`Unity/GetBubble?id=${id}`);
};

export const downloadFile = (id: any) => {
  return progressApi.get("/Unity/getFile" + `?id=${id}`);
};

// Notes

export const createNote = (data: any) => {
  return progressApi.post("/Unity/CreateNote", data);
};

export const updateNote = (data: any) => {
  return progressApi.post("/Unity/UpdateNote", data);
};

export const deleteNote = (id: any) => {
  return progressApi.get("/Unity/DeleteNote" + `?id=${id}`);
};

// Bubbles

export const createBubble = (data: any) => {
  return progressApi.post("/Unity/CreateBubble", data);
};

export const updateBubble = (data: any) => {
  return progressApi.post("/Unity/UpdateBubble", data);
};

export const deleteBubble = (id: any) => {
  return progressApi.get("/Unity/DeleteBubble" + `?id=${id}`);
};

export const createWidget = (data: any) => {
  return progressApi.post("/Unity/CreateUnityWidget", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateWidget = (data: any) => {
  return progressApi.post("/Unity/UpdateUnityWidget", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateWidgetPosition = (data: any) => {
  return progressApi.post("/Unity/UpdateUnityWidgetCordinates", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteWidget = (id: number) => {
  return progressApi.post("/Unity/DeleteUnityWidget" + `?id=${id}`);
};

export const getAllWidgets = () => {
  return progressApi.get("/Unity/GetUnityWidgetList");
};

export const getWidget = (id: number) => {
  return progressApi.get('/Unity/GetUnityWidget' + `?id=${id}`);
};

export const getWidgetsMeta = () => {
  return progressApi.get('/UnityData/GetUnityWidgetMeta');
};

export const getWidgetsData = () => {
  return progressApi.get('/UnityData/GetUnityWidgetData');
};

export const getLabelsMeta = () => {
  return progressApi.get("/Unity/GetUnityLabelMeta");
};

export const getLabel = (id: any) => {
  return progressApi.get(`Unity/GetLabel?id=${id}`);
};

export const createLabel = (data: any) => {
  return progressApi.post("/Unity/CreateLabel", data);
};

export const updateLabel = (data: any) => {
  return progressApi.post("/Unity/UpdateLabel", data);
};

export const deleteLabel = (id: any) => {
  return progressApi.get("/Unity/DeleteLabel" + `?id=${id}`);
};

export const updateLabelPos = (data: any) => {
  return progressApi.post("/Unity/UpdateLabelCordinates", data);
};